export default {
    'name': 'caret-light',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M17.7245 16.2931C18.1151 16.6837 18.7482 16.6837 19.1387 16.2931C19.5293 15.9026 19.5293 15.2694 19.1387 14.8789L12.1211 7.86124C11.9335 7.6737 11.6792 7.56834 11.414 7.56834C11.1488 7.56834 10.8944 7.6737 10.7069 7.86124L3.6892 14.8789C3.29867 15.2694 3.29867 15.9026 3.6892 16.2931C4.07972 16.6837 4.71289 16.6837 5.10341 16.2931L11.414 9.98256L17.7245 16.2931Z\' fill=\'#006CFD\'/>'
}
